import io from "socket.io-client";
const iniSocket = io();

export default function (state = iniSocket) {
  return state;
}
